<template>
  <v-card>
    <v-card-title>
      <h2>Category Descriptions</h2>
      <p>
        Here you can change the description displayed under each provider category. This will be displayed in the resource center provider list page.
      </p>
    </v-card-title>

    <v-card-text>
      <v-tabs>
        <v-tab
          v-for="category in categories"
          :key="category">
          {{ categoryTitle(category) }}
        </v-tab>

        <v-tab-item
          v-for="category in categories"
          :key="category">
          <v-textarea
            v-model="descriptions[category]"
            :loading="loading"
            :disabled="loading || saving"
            :placeholder="`Description for ${categoryTitle(category)}`"
            outlined
            @input="isDirty = true">
          </v-textarea>
        </v-tab-item>
      </v-tabs>
    </v-card-text>

    <v-card-actions>
      <v-spacer />

      <button
        class="default-btn blue"
        :disabled="loading || saving || !isDirty"
        @click="save">
        Save Changes
        <v-icon v-if="saving" right>
          mdi-loading mdi-spin
        </v-icon>
      </button>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminProviderDescriptions',

  data: () => ({
    categories: [
      'attorney',
      'eo',
      'compliance',
      'cpa',
    ],
    descriptions: {
      attorney: '',
      eo: '',
      compliance: '',
      cpa: '',
    },

    loading: true,
    saving: false,
    isDirty: false,
  }),

  computed: {
    ...mapGetters('feathers', ['apiMeta']),
  },

  created () {
    this.getProviderDescriptions()
  },

  methods: {
    async getProviderDescriptions () {
      this.loading = true
      try {
        const results = await this.apiMeta.get('providerDescriptions')
        this.descriptions = results.value
      } catch (error) {
        this.addErrorAlert(`Could not retrieve category descriptions: ${error.message}`)
      }

      this.loading = false
    },

    async save () {
      if (this.saving) return
      this.saving = true

      try {
        await this.apiMeta.patch('providerDescriptions', {
          value: this.descriptions,
        })

        this.isDirty = false
      } catch (error) {
        this.addErrorAlert(`Could not save category descriptions: ${error.message}`)
      }

      this.saving = false
    },

    categoryTitle (category) {
      switch (category) {
        case 'attorney': return 'Attorneys'
        case 'eo': return 'E&O Providers'
        case 'compliance': return 'Compliance Consultants'
        case 'cpa': return 'CPAs'
        default: return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  margin-bottom: 80px;

  .v-card__title {
    flex-direction: column;
    align-items: flex-start;
    background-color: $accentBlue;

    h2 {
      color: white !important;
      font-family: "Sansation Bold", sans-serif;
      font-size: 18px;
    }

    p {
      margin: 0;
      color: white !important;
      font-family: "Sansation Regular", sans-serif;
      font-size: 14px;
    }
  }
}

::v-deep .v-tabs-bar__content {
  justify-content: space-around !important;
}
</style>
